import ReviewBox from '../review-box/review-box.component';
import {
  useTheme,
  useMediaQuery,
  Box,
  Typography,
  Grid,
  IconButton,
} from '@mui/material';
import { useState, useEffect } from 'react';
import { NavigateNext, ChevronLeft } from '@mui/icons-material';

const reviewList = [
  {
    id: 1,
    userName: 'Jennifer L.',
    commentary:
      'O pessoal da Assegurados me atendeu super bem. ' +
      'Eu não sabia qual seguro exatamente escolher e eles me deram ' +
      'todo suporte necessário para que eu pudesse viajar tranquila. Recomendo.',
    rating: 9,
  },
  {
    id: 2,
    userName: 'João C.',
    commentary:
      'Nunca tinha usado um site de cotação de seguro viagem antes, mas a Assegurados me surpreendeu. ' +
      'Foi fácil, rápido e encontrei um seguro que atendia todas as minhas necessidades.',
    rating: 10,
  },
  {
    id: 3,
    userName: 'Rogério S.',
    commentary:
      'Com poucos cliques encontrei o seguro viagem que atendesse às exigências do país que viajei. Fácil e rápido e usar. Indiquei para outros.',
    rating: 10,
  },
  {
    id: 4,
    userName: 'Gabriela M.',
    commentary:
      'Precisava de um seguro viagem com cobertura para doenças preexistentes e achei que seria impossível encontrar um que me atendesse. ' +
      'Mas a Assegurados me surpreendeu e me ajudou a encontrar a opção perfeita. Recomendo muito!',
    rating: 9,
  },
];

const ReviewsSlider = () => {
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [reviewsIdxToShow, setReviewsIdxToShow] = useState(() => {
    return isMobile ? [0] : [0, 1, 2];
  });

  const nextReviewClickHandler = () => {
    let newReviewsToShow = [];
    reviewsIdxToShow.map((id) => {
      if (id + 1 >= reviewList.length) {
        newReviewsToShow.push(0);
      } else {
        newReviewsToShow.push(id + 1);
      }
    });
    setReviewsIdxToShow(newReviewsToShow);
  };

  const previousReviewClickHandler = () => {
    let newReviewsToShow = [];
    reviewsIdxToShow.map((id) => {
      if (id - 1 < 0) {
        newReviewsToShow.push(reviewList.length - 1);
      } else {
        newReviewsToShow.push(id - 1);
      }
    });
    setReviewsIdxToShow(newReviewsToShow);
  };

  useEffect(() => {
    const currentIdx = reviewsIdxToShow[0];
    setReviewsIdxToShow(
      isMobile
        ? [currentIdx]
        : [
            currentIdx,
            (currentIdx + 1) % reviewList.length,
            (currentIdx + 2) % reviewList.length,
          ]
    );
  }, [isMobile]);

  let displayedReviews = [];

  reviewsIdxToShow.forEach((idx) => displayedReviews.push(reviewList[idx]));

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          backgroundColor: `${theme.palette.grey[50]}`,
          borderRadius: `${theme.spacingValues.large}`,
          padding: `${theme.spacingValues.small} ${theme.spacingValues.medium}`,
          width: 'fit-content',
        }}
      >
        <Typography sx={{ color: `${theme.palette.primary.main}` }}>
          Depoimentos
        </Typography>
      </Box>
      <Typography
        variant="h3"
        color={theme.palette.primary.contrastText}
        sx={{
          maxWidth: '500px',
          marginTop: theme.spacingValues.medium,
          textAlign: 'center',
        }}
      >
        O que{' '}
        <span style={{ color: theme.palette.primary.main }}>
          nossos clientes tem a dizer
        </span>{' '}
        sobre o Seguro Viagem
      </Typography>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          margin: '0 auto',
          marginTop: '2rem',
          padding: '0 2rem',
          maxWidth: 'lg',
          width: '100%',
        }}
      >
        <IconButton
          onClick={previousReviewClickHandler}
          sx={{
            color: 'white',
            height: '2rem',
            width: '2rem',
            padding: '0.25rem',
            '&:hover': {
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
            },
          }}
        >
          <ChevronLeft
            sx={{
              fontSize: '1.5rem',
            }}
          />
        </IconButton>

        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: {
              xs: '1fr',
              sm: 'repeat(2, 1fr)',
              md: 'repeat(3, 1fr)',
            },
            gap: theme.spacing(2),
            '& > *': {
              height: '100%',
            },
          }}
        >
          {displayedReviews.map((review) => (
            <ReviewBox key={review.id} review={review} />
          ))}
        </Box>

        <IconButton
          onClick={nextReviewClickHandler}
          sx={{
            color: 'white',
            height: '2rem',
            width: '2rem',
            padding: '0.25rem',
            '&:hover': {
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
            },
          }}
        >
          <NavigateNext
            sx={{
              fontSize: '1.5rem',
            }}
          />
        </IconButton>
      </Box>
    </Box>
  );
};

export default ReviewsSlider;
